module.exports = __webpack_public_path__ + "static/media/left-arrow-svgrepo-com.96675ed1.svg";